import { FC } from "react";
import Head from "next/head";
import { useNajvaPushNotification } from "./useNajvaPushNotification";
import { NAJVA_CSS_URL, NAJVA_SCRIPT_URL } from "./constants";

const NajvaPushNotification: FC = () => {
  useNajvaPushNotification();

  return (
    <Head>
      <link rel="stylesheet" href={NAJVA_CSS_URL} />
      <script async src={NAJVA_SCRIPT_URL} />
    </Head>
  );
};

export default NajvaPushNotification;
